import {
  AD_FILE,
  FILE_ID,
  FILE_NAME,
  FILE_TYPE,
  FILE_URL,
  MEDIA_TYPE,
  UPLOADED_MEDIA_TYPE
} from '../../../../ReusableFormFields/AdFileUpload/fields'
import { AD_TEXT, CALL_TO_ACTION, LANDING_PAGE_URL } from '../../fields'
import { OPTION_YES } from '../../../../../constants/forms'
import { IS_QUARANTINE } from '../../../../reusableFields'

export const NAME = 'name'
// identity
export const IDENTITY = 'identity'
export const IDENTITY_ID = 'identity_id'
export const IDENTITY_NAME = 'display_name'
export const IDENTITY_TYPE = 'identity_type'
export const identityTypes = {
  AUTH_CODE: 'AUTH_CODE',
  CUSTOMIZED_USER: 'CUSTOMIZED_USER',
  TT_USER: 'TT_USER',
  BC_AUTH_TT: 'BC_AUTH_TT'
}
// video uploading
export const VIDEO_OPTION = 'video_option'
export const VIDEO_UPLOAD_OPTION = 'video_upload_option'
export const VIDEO_FROM_LIBRARY_OPTION = 'video_from_library_option'
export const VIDEO_THUMBNAIL_URL = 'video_thumbnail_url'

// viewability and brand safety
export const VIEWABILITY_AND_BRAND_SAFETY_OPTION = 'viewability_and_brand_safety_option'
export const VIEWABILITY_POSTBID_PARTNER = 'viewability_postbid_partner'
export const VIEWABILITY_VAST_URL = 'viewability_vast_url'
export const BRAND_SAFETY_POSTBID_PARTNER = 'brand_safety_postbid_partner'
export const BRAND_SAFETY_VAST_URL = 'brand_safety_vast_url'

export const MOAT = 'MOAT'
export const DOUBLE_VERIFY = 'DOUBLE_VERIFY'
export const IAS = 'IAS'
export const ZEFR = 'ZEFR'

export const viewabilityPartnerOptions = [
  { value: MOAT, label: 'Moat' },
  { value: DOUBLE_VERIFY, label: 'DoubleVerify' },
  { value: IAS, label: 'IAS' }
]

export const brandSafetyPartnerOptions = [
  { value: DOUBLE_VERIFY, label: 'DoubleVerify' },
  { value: ZEFR, label: 'Zefr' },
  { value: IAS, label: 'IAS' }
]

export const initialTikTokVideoFileValues = {
  [AD_FILE]: {},
  [FILE_NAME]: '',
  [FILE_URL]: '',
  [FILE_ID]: '',
  [FILE_TYPE]: '',
  [MEDIA_TYPE]: '',
  [UPLOADED_MEDIA_TYPE]: '',
  [VIDEO_THUMBNAIL_URL]: ''
}

export const getInitialValues = isInternalAdCreation => ({
  [NAME]: '',
  [IDENTITY]: undefined,
  [LANDING_PAGE_URL]: 'https://',
  [AD_TEXT]: '',
  [CALL_TO_ACTION]: 'LEARN_MORE',

  // video file
  [VIDEO_OPTION]: VIDEO_UPLOAD_OPTION,
  ...initialTikTokVideoFileValues,

  // viewability and brand safety
  [VIEWABILITY_AND_BRAND_SAFETY_OPTION]: OPTION_YES,
  [VIEWABILITY_POSTBID_PARTNER]: '',
  [VIEWABILITY_VAST_URL]: 'https://',
  [BRAND_SAFETY_POSTBID_PARTNER]: '',
  [BRAND_SAFETY_VAST_URL]: 'https://',
  [IS_QUARANTINE]: isInternalAdCreation
})
